import { createSlice } from "@reduxjs/toolkit";
import { forgotPassword } from "../actions/forgotPasswordActions";

const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState: {
    status: "idle",
    message: "",
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(forgotPassword.pending, (state) => {
        state.status = "loading";
        state.message = "";
        state.error = "";
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default forgotPasswordSlice.reducer;
